import React from 'react'

// material ui
import Container from '@mui/material/Container'

// components
import Typography from '@mui/material/Typography'

const SectionSubheader = props => {
  const { children } = props

  return (
    <Container>
      <Typography variant='body1'>{children}</Typography>
    </Container>
  )
}

export default SectionSubheader
